var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-rich-text-input',{staticClass:"m-3",attrs:{"labels":{
    urlPlaceholder: _vm.$t('content.urlPlaceholder'),
    ok: _vm.$t('content.ok'),
    openLinkInNewTab: _vm.$t('content.openLinkInNewTab'),
  }},on:{"input":function($event){return _vm.$emit('update-value', $event)}},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})}
var staticRenderFns = []

export { render, staticRenderFns }